<template>
    <div class="WBMDXM">
        <div class="title">
            <span>我报名的项目</span>
        </div>
        <div v-if="showList.length">
            <div v-for="(data, index) in showList" :key="index" class="list">
                <div class="left">
                    <div style="margin-right: 20px;">
                        <img :src="data.image" style="width: 240px;height: 190px;">
                    </div>
                    <div>
                        <div style="display: flex;align-items: center;margin-bottom: 16px;">
                            <span class="title1">{{
                                data.projectName }}</span>
                            <span v-if="data.status == 4" class="status" style="background-color: #F3AE3D;">报名中</span>
                            <span v-if="data.status == 5" class="status" style="background-color: #F56C6C;">报名结束</span>
                            <span v-if="data.status == 6" class="status" style="background-color: #F3AE3D;">竞价中</span>
                            <span v-if="data.status >= 7" class="status" style="background-color: #F56C6C;">已结束</span>
                        </div>
                        <div style="display: flex;flex-direction: column;">
                            <span style="margin-bottom: 8px;" class="detail">当前价：<span style="color: #FC5C5C;">￥{{
                                data.currentPrice }} 元</span></span>
                            <span style="margin-bottom: 8px;"
                                class="detail">项目类型：{{ data.type == 1 ? '招投标项目' : (data.type == 2 ? '供应项目' : '需求项目') }}</span>
                            <span class="detail">项目编号:{{ data.projectNumber }}</span>
                            <span class="detail">创建日期:{{
                                data.applyTime }}</span>

                        </div>
                    </div>
                </div>
                <div class="right">

                    <!-- <span v-if="data.status == 1" class="status"
                        style="background-color: #F56C6C;font-size: 26px;padding: 6px 12px;margin-bottom: 8px;cursor: pointer;">立即参与</span> -->
                    <span class="status"
                        style="background-color: #F56C6C;font-size: 26px;padding: 6px 12px;cursor: pointer;"
                        @click="toDetail(data)">项目详情</span>
                </div>
            </div>
            <div class="operation">



                <el-pagination @current-change="handleCurrentChange" :current-page="checkPage" :page-size="pageNum"
                    layout="total,  prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <div v-else style="display: flex;align-items: center;justify-content: center;height: 700px;">
            <img src="@/assets/img/empty.png" style="width: 286px;height: 228px;">
        </div>
    </div>
</template>

<script>
import { applyProjectList } from "../../api/交易项目详情.js";
export default {
    data() {
        return {
            // 当前查看页数
            checkPage: 1,
            // 一页展示条数
            pageNum: 1,
            pageSize: 10,
            // 全部条数
            total: null,
            // 是否展示选择每页展示条数下拉框
            showCheckPageNumber: false,
            showList: [

            ],
        }
    },
    created() {
        this.getList()
    },
    methods: {
        getList() {
            applyProjectList({
                pageNum: this.pageNum,
                pageSize: this.pageSize,
            }).then(res => {
                this.showList = res.data.rows;
                this.total = res.data.total;

            })
        },
        // 翻页事件
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pageNum = val;
            this.getList();
        },
        // 选择页数事件
        showPageNum() {
            this.showCheckPageNumber = !this.showCheckPageNumber
        },
        checkPageNum(num) {
            console.log(num);
            this.pageNum = num;
            this.getList();
        },
        toDetail(data) {
            if (data.type == 2) {
                this.$router.push({ path: '/tradingProject/pressCenterDetail', query: { id: data.projectId, type: 2 } });
            } else if (data.type == 1) {
                this.$router.push({ path: '/bidDetail', query: { id: data.projectId, type: 1 } });
            } else if (data.type == 3) {
                this.$router.push({ path: '/demandDetail', query: { id: data.projectId, type: 3 } });
            }
        }
    },
}
</script>

<style scoped>
* {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
}

.WBMDXM {
    box-shadow: 0px 0px 25px 4px rgba(90, 90, 90, 0.12);
    padding: 24px 30px;
    display: flex;
    flex-direction: column;
    min-height: 800px;
}

.title {
    padding-bottom: 20px;
    font-size: 30px;
    color: #6681EA;
    border-bottom: 1px solid #6681EA;
}

.list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px 0 20px;
    border-bottom: 1px solid #C0C4CC;
}

.left {
    display: flex;
    align-items: center;
}

.title1 {
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 500;
    color: #222324;
    font-size: 26px;
    max-width: 600px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.status {
    padding: 4px 8px;
    border-radius: 5px;
    white-space: nowrap;
    color: #fff;
    font-size: 20px;
}

.detail {
    font-size: 22px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #616161;
    margin-bottom: 8px;
}

.right {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.operation {
    display: flex;
    align-items: center;
    justify-content: right;
    margin-top: 30px;
    position: relative;
}

.pageNum {
    padding: 4px 10px;
    border: 1px solid #C0C4CC;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    margin: 0 12px;
    position: relative;
}

.pageNum {
    position: absolute;
    display: flex;
    flex-direction: column;
    top: 100%;
    left: 0;
    background-color: #fff;
    border-radius: 10px;
    z-index: 10000;
    width: 100%;
    user-select: none;
    border: 1px solid #ddd;
}

.pageNum>span {
    padding: 6px 10px;
    font-size: 18px;
    font-weight: 400;
    cursor: pointer;
    border-bottom: 1px #ddd solid;
}

.pageNum>span:hover {
    padding: 6px 10px;
    font-size: 18px;
    font-weight: 400;
    cursor: pointer;
    border-bottom: 1px #ddd solid;
    background-color: #eee;
}

.el-pagination {
    display: flex;
}
</style>